import type { ScopedThreadRef } from "@cmmd-forge/contracts";

export type ProjectLeadCompanionDock = "floating" | "right";

export interface ProjectLeadCompanionPosition {
  readonly x: number;
  readonly y: number;
}

export interface ProjectLeadCompanionState {
  readonly threadRef: ScopedThreadRef | null;
  readonly open: boolean;
  readonly minimized: boolean;
  readonly dock: ProjectLeadCompanionDock;
  readonly position: ProjectLeadCompanionPosition | null;
}

export const INITIAL_PROJECT_LEAD_COMPANION_STATE: ProjectLeadCompanionState = {
  threadRef: null,
  open: false,
  minimized: false,
  dock: "floating",
  position: null,
};

export function clampProjectLeadCompanionPosition(input: {
  readonly position: ProjectLeadCompanionPosition;
  readonly viewportWidth: number;
  readonly viewportHeight: number;
  readonly width: number;
  readonly height: number;
}): ProjectLeadCompanionPosition {
  const margin = 12;
  return {
    x: Math.max(margin, Math.min(input.position.x, input.viewportWidth - input.width - margin)),
    y: Math.max(margin, Math.min(input.position.y, input.viewportHeight - input.height - margin)),
  };
}

export function openProjectLeadCompanionState(
  state: ProjectLeadCompanionState,
  threadRef: ScopedThreadRef,
): ProjectLeadCompanionState {
  return { ...state, threadRef, open: true, minimized: false };
}

export function shouldRenderProjectLeadCompanion(input: {
  readonly companion: ProjectLeadCompanionState;
  readonly routeThreadRef: ScopedThreadRef | null;
}): boolean {
  const threadRef = input.companion.threadRef;
  if (!input.companion.open || threadRef === null) return false;
  return !(
    input.routeThreadRef?.environmentId === threadRef.environmentId &&
    input.routeThreadRef.threadId === threadRef.threadId
  );
}
